import React from "react";
import { connect } from "react-redux";
import { MaterialTextField } from "./MaterialInput";
import IconButton from '@material-ui/core/IconButton';
import InnerLink from './InnerLink';
import { reduxForm, Field, reset } from "redux-form";
import * as agent from "../agent";
import { CONTRACT_UPDATED } from "../constants/actionTypes";
import { FormattedDate, FormattedTime } from "react-intl";
import Grid from '@material-ui/core/Grid';
import SubmitButton from './SubmitButton';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

class securityFSSP extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: "INACTIVE",
            result: [],
            error: null
        }
    }
    onRequireFSSP = () => {
        const { clientDetails: { firstname, lastname, patronymic, birthDate } } = this.props;
        this.setState({ status: "PENDING", result: [] });
        agent.Clients.fsspinfo(firstname, lastname, patronymic, birthDate)
        .then(res => {
            this.setState({ status: "SUCCESS", result: res })
        })
        .catch(err => {
            this.setState({ status: "REJECT", result: [], error: err.message })
        })

    }
    render() {
        const { contractId, onAddFSSPCheck, onResolveProblem, handleSubmit, fssp = [] } = this.props;
        const { status, result, error} = this.state;
        return (
            <Paper className="common-paper m20">
                <Grid container spacing={32} >
                    <Grid item xs>
                        <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={16}>
                            <Grid item>
                                <Typography variant="h5" >Проверка:</Typography>
                            </Grid>
                            { ({
                                "INACTIVE": (<Grid item ><Typography paragraph >Проверка не проводилась</Typography></Grid>),
                                "PENDING": (<Grid item >
                                                <Typography paragraph >Поиск информации. Ожидайте...</Typography>
                                                <CircularProgress />
                                            </Grid>),
                                "SUCCESS": (<Grid item >
                                                {result.length > 0 ?
                                                    <Table padding="dense">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell >Должник</TableCell>
                                                                <TableCell>ИП</TableCell>
                                                                <TableCell>Дата, причина окончания</TableCell>
                                                                <TableCell>Предмет исполнения</TableCell>
                                                                <TableCell>Отдел судебных приставов</TableCell>
                                                                <TableCell>Пристав-исполнитель</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            { result.map( ({ name, details, ip_end, subject, department, bailiff = "" }, i) => {
                                                                return  (
                                                                    <TableRow key={i}>
                                                                        <TableCell >{name}</TableCell>
                                                                        <TableCell>{details}</TableCell>
                                                                        <TableCell>{ip_end}</TableCell>
                                                                        <TableCell>{subject}</TableCell>
                                                                        <TableCell>{department}</TableCell>
                                                                        <TableCell>{bailiff.replace(/<.+?>/g,'\n')}</TableCell>
                                                                    </TableRow>
                                                                );
                                                            } )}
                                                        </TableBody>
                                                    </Table> : <Typography paragraph >Данные отсутствуют</Typography>
                                                }
                                            </Grid>),
                                "REJECT":  (<Grid item ><Typography paragraph >Возникла ошибка: {error}</Typography></Grid>)
                            })[status] }
                            <Grid item>
                                <Button type="submit"
                                        onClick={this.onRequireFSSP}
                                        size="large"
                                        color="primary"
                                        variant="contained"> Запрос информации </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs>
                        <Typography variant="h5" >Комментарии:</Typography>
                    { fssp.length ?
                        <Table padding="dense">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Дата</TableCell>
                                    <TableCell>Автор</TableCell>
                                    <TableCell>Комментарий</TableCell>
                                    <TableCell>&nbsp;</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { fssp.map(({date, author: {id, fullname = ""} = {}, note, _id, status}, i) =>
                                    <TableRow key={i}>
                                        <TableCell>
                                            <FormattedDate value={date}
                                                           day="numeric"
                                                           month="numeric"
                                                           year="numeric" />
                                            <br />
                                            <FormattedTime value={date}
                                                           hour="numeric"
                                                           minute="numeric"
                                                           second="numeric" />
                                        </TableCell>
                                        <TableCell>
                                            { id ? <InnerLink href={`/user/${id}`} label={fullname.split(" ")[0]} /> : "" }
                                        </TableCell>
                                        <TableCell>
                                            {status && !note ? "Чисто" : note }
                                        </TableCell>
                                        <TableCell>
                                            {
                                                <IconButton disabled={status} onClick={() => onResolveProblem("fssp", _id)} >
                                                    { status ? <CheckCircleOutlineIcon /> : <HighlightOffIcon /> }
                                                </IconButton>
                                            }
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table> : <Typography paragraph>Проверок еще не было</Typography>
                    }
                        <form className="common-form"
                              onSubmit={handleSubmit(check => onAddFSSPCheck(contractId, check))} >
                              <Field component={MaterialTextField}
                                     name="note"
                                     placeholder="Чисто"
                                     label="Комментарий" />
                              <SubmitButton label="Добавить" />
                        </form>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
};


const SecurityFSSP = connect(
    null,
    dispatch => ({
        onAddFSSPCheck: (contractId, check) =>
            agent.Contract.addFSSPCheck(contractId, check)
            .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
            .then(dispatch(reset('security-fssp'))),
        onResolveProblem: (table, checkId) =>
            agent.Contract.resolveProblem(table, checkId)
            .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
    })
)(reduxForm({form: "security-fssp"})(securityFSSP));

export default SecurityFSSP;



// WEBPACK FOOTER //
// ./src/components/SecurityFSSP.js